import type { geoLocation } from "$lib/datamodel";
import { writable } from "svelte/store";


export const geolocation = writable<geoLocation>({latitude: 0, longitude: 0, ip: ""} as geoLocation);
